import { render, staticRenderFns } from "./videos.page.vue?vue&type=template&id=ffcc8ef2&scoped=true&"
import script from "./videos.page.vue?vue&type=script&lang=js&"
export * from "./videos.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc8ef2",
  null
  
)

export default component.exports